import React from 'react';
import { Button, LoadingButton, ModalHeader, ModalBody, ModalFooter, Typography, } from '@one-thd/sui-atomic-components';
import { AddressParagraph } from '../address-paragraph/address-paragraph';
export const ICDefaultAddressMsg = "This is also your address for Instant Checkout. You'll need to set up where you get items before you shop with Instant Checkout again.";
export const DeleteAddressModal = ({ address, hideModal, onConfirmDelete, isLoading, }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(ModalHeader, { onClose: hideModal }, "Do You Want To Delete This Address?"),
        React.createElement(ModalBody, null,
            React.createElement(AddressParagraph, { address: address }),
            address.instantCheckoutDefault && (React.createElement("div", { className: "sui-mt-4" },
                React.createElement(Typography, null, ICDefaultAddressMsg)))),
        React.createElement(ModalFooter, { position: "end" },
            React.createElement("div", { className: "sui-flex sui-gap-4 sm:sui-gap-4 sui-flex-col-reverse sui-w-full sm:sui-flex-row sm:sui-w-auto" },
                React.createElement(Button, { variant: "secondary", onClick: hideModal }, "No"),
                React.createElement(LoadingButton, { loading: isLoading, variant: "primary", onClick: onConfirmDelete, "data-testid": "confirm-delete-address-btn" }, "Yes, Delete Address")))));
};
DeleteAddressModal.displayName = 'DeleteAddressModal';
